export default "__VITE_ASSET__rqOIS6hk__"